import { useSearchParams } from 'react-router-dom';
import { DirectionEnum, OrderBy } from 'src/generated/operations.ts';

const DIRECTION_REGEXP = /^([+-]+)/;

export function useOrderBy(
    name: string,
): [OrderBy[], (prev: URLSearchParams, newOrder: OrderBy[]) => URLSearchParams] {
    const [searchParams] = useSearchParams();
    let orderBy :OrderBy[] = [];
    const order = searchParams.get(name);
    if (order) {
        const direction = order.slice(0, 1) === '-' ? DirectionEnum.Desc : DirectionEnum.Asc;
        orderBy = order
            .replace(DIRECTION_REGEXP, '')
            .split(',')
            .map((item) => ({
                id: item,
                direction,
            }));
    }
    return [
        orderBy,
        (prev: URLSearchParams, newOrder: OrderBy[]): URLSearchParams => {
            if (newOrder.length > 0) {
                const direction = newOrder[0].direction === DirectionEnum.Desc ? '-' : '+';
                prev.set(
                    name,
                    direction + newOrder.map((item) => item.id).join(','),
                );
            } else {
                prev.delete(name);
            }
            return prev;
        },
    ];
}
